<template>
  <v-avatar class="custom-avatar" color="accent" size="12vh">
    <img :src="image" />
  </v-avatar>
</template>

<script>

export default {

  name: "change_image",
  props: {
    image: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="css" scoped>
.custom-avatar {
  border: 3px solid #ffffff;
  box-shadow: 0px 4px 20px rgba(203, 191, 178, 0.62);
}

</style>
